<div class="skeleton-loader">
  <!-- Card skeleton pattern -->
  <ng-container *ngIf="type === 'card'">
    <div class="skeleton-card" *ngFor="let item of [].constructor(count)">
      <app-skeleton height="120px"></app-skeleton>
    </div>
  </ng-container>

  <!-- List skeleton pattern -->
  <ng-container *ngIf="type === 'list'">
    <div class="skeleton-list" *ngFor="let item of [].constructor(count)">
      <app-skeleton height="20px" width="90%"></app-skeleton>
      <app-skeleton height="16px" width="60%"></app-skeleton>
      <app-skeleton height="16px" width="40%"></app-skeleton>
    </div>
  </ng-container>

  <!-- Detail skeleton pattern -->
  <ng-container *ngIf="type === 'detail'">
    <div class="skeleton-detail">
      <div class="skeleton-detail__header">
        <app-skeleton height="40px" width="70%"></app-skeleton>
        <app-skeleton height="20px" width="30%"></app-skeleton>
      </div>
      <div class="skeleton-detail__body">
        <div class="skeleton-detail__section">
          <app-skeleton height="24px" width="40%"></app-skeleton>
          <app-skeleton height="100px" width="100%"></app-skeleton>
        </div>
        <div class="skeleton-detail__section">
          <app-skeleton height="24px" width="35%"></app-skeleton>
          <div class="skeleton-detail__grid">
            <app-skeleton height="80px" width="100%"></app-skeleton>
            <app-skeleton height="80px" width="100%"></app-skeleton>
            <app-skeleton height="80px" width="100%"></app-skeleton>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Custom skeleton pattern -->
  <ng-container *ngIf="type === 'custom'">
    <ng-content></ng-content>
  </ng-container>

  <!-- Loading message -->
  <p *ngIf="message" class="skeleton-loader__message">{{ message }}</p>
</div>
